var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"accountCenter"}},[(_vm.isHotel)?_c('storeCenter'):_c('hotelCenter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }